<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
                <div class="divisor32"></div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <inputCustom [titulo]="'Tipo de evaluación'" [disabled]="true" [(ngModel)]="accion.accion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>
                <h5>Asigne las evaluaciones que cada colaborador del departamento debe llevar a cabo</h5>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <dropdownCustom [titulo]="'Filtro por departamento'" [(ngModel)]="asignacionentidad.departamentoid"
                        [opciones]="SelDepartamento" propiedad="departamentoid" (ngModelChange)="SetColaboradores($event)" displayValor="nombre"
                        valorName="departamentoid"></dropdownCustom>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <dropdownCustom [titulo]="'Persona a evaluar (integrantes de mi equipo)'" [(ngModel)]="asignacionentidadrepuesto.puestoporcolaboradorid"
                        [opciones]="listgrupocolaboradores" propiedad="puestoporcolaboradorid" (ngModelChange)="SetPuestoSuperiorYInferior($event)" displayValor="nombreypuesto"
                        valorName="puestoporcolaboradorid"></dropdownCustom>
                    </div>

                </div>
                <div>
                    <h5>Evaluaciones Obligatorias</h5>
                                <!-- datos -->
                                    <div >
                                        <dx-data-grid
                                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                        id="tabla"
                                        [columnAutoWidth]="true"
                                        [dataSource]="DataColaboradores"
                                        [hoverStateEnabled]="true"
                                        [showColumnHeaders]="true"
                                        >
                                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>
                
                                        <dxo-search-panel
                                            [visible]="true"
                                            [width]="240"
                                            placeholder="{{'Buscar' | translate}}">
                                        </dxo-search-panel>
                
                                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                
                                        <dxo-pager
                                            [visible]="true"
                                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                            [displayMode]="sistemaService.tablaPaginacionModo"
                                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                            [showInfo]="sistemaService.tablaPaginacionInfo"
                                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                        </dxo-pager>
                                        <dxi-column
                                            dataField="colaborador"
                                            caption="Persona que lo evalúa">
                                        </dxi-column>
                                        <dxi-column
                                            dataField="relacion"
                                            caption="Relación">
                                        </dxi-column>
                                        <dxi-column
                                            dataField="departamento"
                                            caption="Departamento">
                                        </dxi-column>
                                        <dxi-column
                                        dataField="puesto"
                                        caption="Puesto">
                                    </dxi-column>
                                    </dx-data-grid>
                            </div>
                </div>

                <div>
                    <h5>Evaluaciones complementarias</h5>
                    <div class="row margen">
                        <div class="col-12">
                            <div class="panelBotonesFiltro mixto">
                                <button matTooltip="Asignar Complementarios"
                                    class="btn boton botonXS" [disabled]="visualizar"
                                    (click)="Modal()">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Agregar'}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                                <!-- datos -->
                                    <div >
                                        <dx-data-grid
                                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                        id="tabla"
                                        [columnAutoWidth]="true"
                                        [dataSource]="DataColaboradoresComplementarias"
                                        [noDataText]="'Sin Datos'"
                                        [hoverStateEnabled]="true"
                                        [showColumnHeaders]="true"
                                        >
                                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>
                
                                        <dxo-search-panel
                                            [visible]="true"
                                            [width]="240"
                                            placeholder="{{'Buscar' | translate}}">
                                        </dxo-search-panel>
                
                                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                
                                        <dxo-pager
                                            [visible]="true"
                                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                            [displayMode]="sistemaService.tablaPaginacionModo"
                                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                            [showInfo]="sistemaService.tablaPaginacionInfo"
                                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                        </dxo-pager>
                                        <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                                        <dxi-column [allowEditing]="!visualizar"
                                            [allowExporting]="false"
                                            caption="Acciones"
                                            cellTemplate="cellAcciones"
                                            alignment="center"
                                            [minWidth]="120">
                
                                        </dxi-column>
                                        <dxi-column [allowEditing]="!visualizar"
                                        alignment="center"
                                        dataField="activo"
                                        caption="Selección"
                                        dataType="boolean"
                                    >
                                    </dxi-column>
                                        <dxi-column [allowEditing]="false"
                                            dataField="colaborador"
                                            caption="Persona que lo evalúa">
                                        </dxi-column>
                                        <dxi-column [allowEditing]="false"
                                            dataField="departamento"
                                            caption="Departamento">
                                        </dxi-column>
                                        <dxi-column [allowEditing]="false"
                                        dataField="puesto"
                                        caption="Puesto">
                                    </dxi-column>
                                    <dxi-column [allowEditing]="false"
                                    dataField="relacion"
                                    caption="Relación">
                                </dxi-column>
                                        <!-- Acciones -->
                                        <div *dxTemplate="let cell of 'cellAcciones'">
                                                <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" [class.disabled]="visualizar"  *ngIf="sistemaService.permisos.eliminar && cell.data.relacion != 'Par' ">
                                                    <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                                </a>
                                        </div>
                                    </dx-data-grid>
                            </div>
                </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                            <div class="divisorH16 " ></div>
                            <button matTooltip="Guardar" class="boton botonSM filled"
                            (click)="Guardar()"
                            *ngIf="sistemaService.permisos.agregar && !visualizar">
                            <span> {{'Guardar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<colaboradorevaluacionmodal
    #colaborador
    (respuesta)="GuardarColaborador($event)"
    ></colaboradorevaluacionmodal>